import BaseModelFactory from './base.factory'
import UserDocumentService from './../services/UserDocument.service'
import UserDocument from './../models/user-document.model'

class UserDocumentFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search({ search, pagination, order_by, method }, { Service: UserDocumentService, Model: UserDocument })
  static findById = async id => await this._findBy({ id: id }, { Service: UserDocumentService, Model: UserDocument })
  static findAllByUserId = async id =>
    await this._findAllBy({ user_id: id }, { Service: UserDocumentService, Model: UserDocument })
  static create = payload =>
    this._create(payload, {
      Service: UserDocumentService,
      Model: UserDocument,
    })
}

export default UserDocumentFactory
